// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.content_UPWFZ {
    width: 400px;
    height: 100%;
}

.pad_pDTu4 {
    padding: var(--size-padLarge, 10px);
}

.header_cPmc7 {
    position: relative;
}

.contentArea_xlhGX {
    background: #f3f5f6;
}

.close_oQ0jP {
    position: absolute;
    z-index: 1;
    top: 50%;
    right: 10px;
    transform: translateY(-50%);
}

.successImage_mHSuy {
    margin: 20px auto;
    display: block;
}

.buttonContainer_bXm0d {
    width: 100%;
    background-color: white;
    border-radius: 6px;
    box-shadow: rgba(41, 50, 61, 0.16) 0px 1px 3px;
    padding: 0 10px;
}

.buttonContainer_bXm0d > * {
    border-bottom: 1px solid var(--color-base200) !important;
}

.buttonContainer_bXm0d > *:last-child {
    border-bottom: none !important;
}

.unpairOption_Rfy5w {
    border : 1px solid var( --color-base200 );
    background-color: var( --color-white );
    padding : var( --size-padMedium );
    border-radius : var( --size-padSmall );
}

.unpairOption_Rfy5w > .unpairOption_Rfy5w {
    border : unset;
    background-color: unset;
    padding: unset;
    border-radius: unset;
}

.activeUnpairOption_xi1cr {
    border : 1px solid var( --color-brand200 );
    background-color: var( --color-brand025 );
    padding : var( --size-padMedium );
    border-radius : var( --size-padSmall );
}

.activeUnpairOption_xi1cr > .activeUnpairOption_xi1cr {
    border : unset;
    background-color: unset;
    padding: unset;
    border-radius: unset;
}

.divider_kNAnO {
    width: 100%;
    height: 0px;
    border: 1px solid var( --color-base200 );
}

.container_HPF0_ {
    background: #FFFFFF;
    border: 1px solid var( --color-base100 );
    border-radius: 8px;
    padding: 12px;
}

.nameValueContainer_ydePd {
    flex: 1 !important;
    overflow: hidden !important;
}

.body_cLpkZ {
    font-style: normal !important;
    font-weight: 400 !important;
    font-size: 15px !important;
    line-height: 24px !important;
    color: var( --color-base700 ) !important;
}

.name_wPsAs {
    font-style: normal !important;
    font-weight: 400 !important;
    font-size: 15px !important;
    line-height: 24px !important;
    color: var( --color-base700 ) !important;
}

.value_j7aX5 {
    font-style: normal !important;
    font-weight: 600 !important;
    font-size: 15px !important;
    line-height: 24px !important;
    color: var( --color-base800 ) !important;
}`, "",{"version":3,"sources":["webpack://./../../packages/recovr-plugins/lib/views/pairing/PairingFlow.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,WAAW;IACX,2BAA2B;AAC/B;;AAEA;IACI,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,uBAAuB;IACvB,kBAAkB;IAClB,8CAA8C;IAC9C,eAAe;AACnB;;AAEA;IACI,wDAAwD;AAC5D;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,yCAAyC;IACzC,sCAAsC;IACtC,iCAAiC;IACjC,sCAAsC;AAC1C;;AAEA;IACI,cAAc;IACd,uBAAuB;IACvB,cAAc;IACd,oBAAoB;AACxB;;AAEA;IACI,0CAA0C;IAC1C,yCAAyC;IACzC,iCAAiC;IACjC,sCAAsC;AAC1C;;AAEA;IACI,cAAc;IACd,uBAAuB;IACvB,cAAc;IACd,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,WAAW;IACX,wCAAwC;AAC5C;;AAEA;IACI,mBAAmB;IACnB,wCAAwC;IACxC,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,2BAA2B;AAC/B;;AAEA;IACI,6BAA6B;IAC7B,2BAA2B;IAC3B,0BAA0B;IAC1B,4BAA4B;IAC5B,wCAAwC;AAC5C;;AAEA;IACI,6BAA6B;IAC7B,2BAA2B;IAC3B,0BAA0B;IAC1B,4BAA4B;IAC5B,wCAAwC;AAC5C;;AAEA;IACI,6BAA6B;IAC7B,2BAA2B;IAC3B,0BAA0B;IAC1B,4BAA4B;IAC5B,wCAAwC;AAC5C","sourcesContent":[".content {\n    width: 400px;\n    height: 100%;\n}\n\n.pad {\n    padding: var(--size-padLarge, 10px);\n}\n\n.header {\n    position: relative;\n}\n\n.contentArea {\n    background: #f3f5f6;\n}\n\n.close {\n    position: absolute;\n    z-index: 1;\n    top: 50%;\n    right: 10px;\n    transform: translateY(-50%);\n}\n\n.successImage {\n    margin: 20px auto;\n    display: block;\n}\n\n.buttonContainer {\n    width: 100%;\n    background-color: white;\n    border-radius: 6px;\n    box-shadow: rgba(41, 50, 61, 0.16) 0px 1px 3px;\n    padding: 0 10px;\n}\n\n.buttonContainer > * {\n    border-bottom: 1px solid var(--color-base200) !important;\n}\n\n.buttonContainer > *:last-child {\n    border-bottom: none !important;\n}\n\n.unpairOption {\n    border : 1px solid var( --color-base200 );\n    background-color: var( --color-white );\n    padding : var( --size-padMedium );\n    border-radius : var( --size-padSmall );\n}\n\n.unpairOption > .unpairOption {\n    border : unset;\n    background-color: unset;\n    padding: unset;\n    border-radius: unset;\n}\n\n.activeUnpairOption {\n    border : 1px solid var( --color-brand200 );\n    background-color: var( --color-brand025 );\n    padding : var( --size-padMedium );\n    border-radius : var( --size-padSmall );\n}\n\n.activeUnpairOption > .activeUnpairOption {\n    border : unset;\n    background-color: unset;\n    padding: unset;\n    border-radius: unset;\n}\n\n.divider {\n    width: 100%;\n    height: 0px;\n    border: 1px solid var( --color-base200 );\n}\n\n.container {\n    background: #FFFFFF;\n    border: 1px solid var( --color-base100 );\n    border-radius: 8px;\n    padding: 12px;\n}\n\n.nameValueContainer {\n    flex: 1 !important;\n    overflow: hidden !important;\n}\n\n.body {\n    font-style: normal !important;\n    font-weight: 400 !important;\n    font-size: 15px !important;\n    line-height: 24px !important;\n    color: var( --color-base700 ) !important;\n}\n\n.name {\n    font-style: normal !important;\n    font-weight: 400 !important;\n    font-size: 15px !important;\n    line-height: 24px !important;\n    color: var( --color-base700 ) !important;\n}\n\n.value {\n    font-style: normal !important;\n    font-weight: 600 !important;\n    font-size: 15px !important;\n    line-height: 24px !important;\n    color: var( --color-base800 ) !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"content": `content_UPWFZ`,
	"pad": `pad_pDTu4`,
	"header": `header_cPmc7`,
	"contentArea": `contentArea_xlhGX`,
	"close": `close_oQ0jP`,
	"successImage": `successImage_mHSuy`,
	"buttonContainer": `buttonContainer_bXm0d`,
	"unpairOption": `unpairOption_Rfy5w`,
	"activeUnpairOption": `activeUnpairOption_xi1cr`,
	"divider": `divider_kNAnO`,
	"container": `container_HPF0_`,
	"nameValueContainer": `nameValueContainer_ydePd`,
	"body": `body_cLpkZ`,
	"name": `name_wPsAs`,
	"value": `value_j7aX5`
};
export default ___CSS_LOADER_EXPORT___;
